// extracted by mini-css-extract-plugin
export default {"wrapper":"TimePill_wrapper__DhrcG","blocked":"TimePill_blocked__SuYwl"};